export const codeHighlightingSurfaceTokens = {
  body: 'surface2',
  bodyClassName: 'bg-surface-2',
  controls: 'surface1',
  controlsClassName: 'bg-surface-1',
} as const

export const codeHighlightingSurfaceClassName = `tab-size-2 ${codeHighlightingSurfaceTokens.bodyClassName} m-0 overflow-x-auto rounded-2xl p-4 font-mono text-sm leading-relaxed md:p-6`

/** Semantic token colors shared by static and contenteditable code renderers. */
export const codeHighlightingLexicalTheme = {
  atrule: 'text-error',
  attr: 'text-warning',
  boolean: 'text-info',
  builtin: 'text-primary',
  cdata: 'text-on-surface-secondary italic',
  char: 'text-warning',
  class: 'text-success',
  'class-name': 'text-success',
  comment: 'text-on-surface-secondary italic',
  constant: 'text-info',
  deleted: 'text-error',
  doctype: 'text-on-surface-secondary italic',
  entity: 'text-error',
  function: 'text-success',
  important: 'text-warning',
  inserted: 'text-success',
  keyword: 'text-error',
  namespace: 'text-warning',
  number: 'text-info',
  operator: 'text-error',
  prolog: 'text-on-surface-secondary italic',
  property: 'text-primary',
  punctuation: 'text-on-surface-secondary',
  regex: 'text-warning',
  selector: 'text-success',
  string: 'text-warning',
  symbol: 'text-primary',
  tag: 'text-error',
  url: 'text-primary',
  variable: 'text-info',
} as const
